export const meta = { id: 'O36', slug: 'evidencias-administracao', title: 'Evidências na visão administrativa', description: 'Entenda o papel do Owner na operação de Evidências sem duplicar a avaliação do Mentor.', profile: 'owner', category: 'operacao', type: 'screen', status: 'published', order: 660, keywords: ['evidências','administração','owner','mentor','aluno'], previous: 'O35', next: 'O37', related: ['A11','M08'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Evidências na visão administrativa

A Evidência começa na experiência do Aluno, pode ser analisada pelo Mentor dentro da relação autorizada e pode aparecer para o Owner conforme a visão administrativa disponível no ambiente.

<HelpImage pendingId="O36.1" alt="Visão administrativa de Evidências" />

## Responsabilidades por perfil

- **Aluno:** registra a Evidência;
- **Mentor:** analisa Evidências dos mentorados vinculados;
- **Owner:** acompanha e administra a operação dentro da sua alçada.

<Callout type="important">A visão administrativa não deve ser usada para ignorar as regras de acesso, contexto e responsabilidade já definidas entre Aluno e Mentor.</Callout>
